import { PropTypes } from 'prop-types';

import { useAuthentication } from '@zenbusiness/application-commons-authentication';

import BusinessInfoFields from '../BusinessInfoFields';
import BusinessInfoSummary from '../BusinessInfoSummary';
import ContactInfoFields from '../ContactInfoFields';
import ContactInfoSummary from '../ContactInfoSummary';
import FormProvider from '../FormProvider';

function Form({
  businessFields,
  contactFields,
  isBusinessEditable,
  isContactEditable,
  onContinue
}) {
  const { authenticated } = useAuthentication();

  return (
    <FormProvider onContinue={onContinue}>
      {/** Contact Info - only shown for unauthenticated users */}
      {!authenticated && isContactEditable && <ContactInfoFields fieldsConfig={contactFields} />}
      {!authenticated && !isContactEditable && <ContactInfoSummary />}

      {/* Business Info */}
      {isBusinessEditable ? (
        <BusinessInfoFields fieldsConfig={businessFields} />
      ) : (
        <BusinessInfoSummary />
      )}
    </FormProvider>
  );
}

Form.propTypes = {
  businessFields: PropTypes.object,
  contactFields: PropTypes.object,
  isBusinessEditable: PropTypes.bool,
  isContactEditable: PropTypes.bool,
  onContinue: PropTypes.func.isRequired
};

export default Form;
